const errorConstants = {
  SERVER_ERROR:         'SERVER_ERROR',
  COMMON_ERROR:         'COMMON_ERROR',
  VALIDATION_ERROR:     'VALIDATION_ERROR',
  WRONG_RESPONSE_ERROR: 'WRONG_RESPONSE_ERROR',
  NOT_FOUND_ERROR:      'NOT_FOUND_ERROR',
  NOT_AUTHORIZED_ERROR: 'NOT_AUTHORIZED_ERROR',
};

export default errorConstants;